import { useAuthStore, useCommonStore } from "@enos-monorepo/lib";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

export function useLogout() {
  const { logout } = useAuthStore();
  const { clear } = useCommonStore();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return () => {
    logout();
    clear();
    queryClient.clear();
    navigate("/login");
  };
}
